import React, {FunctionComponent, CSSProperties} from 'react';
import icon from 'src/images/icons/fireworks-white.png';

export type Props = {
  style?: CSSProperties;
  onOpenArticle: (s: string) => void;
};

const Header: FunctionComponent<Props> = ({style, onOpenArticle}) => (
  <header id="header" style={style}>
    <div className="logo">
      <img src={icon} alt="Magenta Creations" height="48" style={{marginTop: '16px'}} />
    </div>
    <div className="content">
      <div className="inner">
        <h1>Magenta Creations</h1>
        <p style={{marginTop: '-1rem', marginBottom: '1rem'}}>Architecture Digitale</p>
        <p>"If things are not failing, you are not innovating enough."</p>
      </div>
    </div>
    <nav>
      <ul>
        <li>
          <a
            onClick={() => {
              onOpenArticle('about');
            }}
          >
            À Propos
          </a>
        </li>
        <li>
          <a
            onClick={() => {
              onOpenArticle('contact');
            }}
          >
            Contact
          </a>
        </li>
      </ul>
    </nav>
  </header>
);

export default Header;
